import React from "react";
import { SignupLayer } from "../components/SignupLayer";

const SignUpPage = () => {
  return (
    <>

      {/* SignUpLayer */}
<SignupLayer />
    </>
  );
};

export default SignUpPage; 
